import HomepageTemplate from "../../../../src/components/Homepage.js";
import * as React from 'react';
export default {
  HomepageTemplate,
  React
};